import { en } from './en'

export const ne = {
  translation: {
    'Welcome to React': 'React र react-i18next मा स्वागत छ',
    yesterday: 'हिजो',
    today: 'आज',

    baseSettings: {
      profile: 'प्रोफाइल',
      snippets: 'स्निपेटहरू',
      phone: 'फोन',
      fax: 'फ्याक्स',
      notifications: 'सूचनाहरू',
      audio: 'अडियो',
      blockedNumbers: 'ब्लक गरिएको नम्बरहरू',
      callCenter: 'कल सेन्टर',
      experiments: 'प्रयोगहरू',
      shortcutKeys: 'सर्टकट कुञ्जीहरू',
      collapse: 'सङ्कुचित गर्नुहोस्',
      expand: 'फैलाउनुहोस्',
      new: 'नयाँ',
    },

    nav: {
      voicemail: 'भ्वाइसमेल',
      calls: 'कलहरू',
      text: 'पाठ',
      messaging: 'सन्देश',
      fax: 'फ्याक्स',
      contacts: 'सम्पर्कहरू',
      settings: 'सेटिङहरू',
      webPhone: 'वेब फोन',
      dashboard: 'ड्यासबोर्ड',
      analytics: 'विश्लेषण',
    },

    faxViewList: {
      titleNoFaxes: 'कुनै फ्याक्स छैन',
      titleNoMatchingFaxes: 'कुनै मेल खाने फ्याक्स छैन',
      subtitleTryRemovingFilters: 'कुनै फिल्टर हटाउनुहोस्',
      subtitleNoFaxes: 'कुनै फ्याक्स छैन',
      buttonTextStartFax: 'फ्याक्स शुरू गर्नुहोस्',
      buttonTextStartFirstFax: 'तपाईंको पहिलो फ्याक्स शुरू गर्नुहोस्',
      searchPlaceholder: 'नाम वा नम्बर खोज्नुहोस्',
      status: {
        failed: 'असफल',
        pending: 'प्रकार',
        sent: 'पठाइएको',
        received: 'प्राप्त गरिएको',
        unknown: 'अज्ञात',
      },
    },

    call: {
      toast: {
        callDeclined: '{{context}} बाट कल अस्वीकार गरियो',
        callEnded: '{{context}} संग कल समाप्त भयो',
        callHeld: '{{context}} संग कल रोकियो',
        callParked: '{{callName}} {{parkingLotName}} मा स्थानान्तरित गरियो',
        callTransferred:
          '{{callName}} {{transferToName}} मा स्थानान्तरित गरियो',
      },
    },

    incomingCallModal: {
      newCallFrom: 'नयाँ कल बाट',
      rejectCall: 'कल अस्वीकार गर्नुहोस्',
      acceptCall: 'कल स्वीकार गर्नुहोस्',
      endAndAccept: 'समाप्त गर्नुहोस् र स्वीकार गर्नुहोस्',
      holdAndAccept: 'रोकियो गर्नुहोस् र स्वीकार गर्नुहोस्',
      parkAndAccept: 'स्थानान्तरित गर्नुहोस् र स्वीकार गर्नुहोस्',
    },

    faxPage: {
      toast: {
        copyLinkSuccess: 'लिंक क्लिपबोर्डमा प्रतिलिपि गरियो',
        copyLinkError: 'लिंक प्रतिलिपि गर्न असफल',
        sendSuccess: 'तपाईंको फ्याक्स अनुक्रममा थपियो र थुप्रा पठाउनेछ',
        sendError: 'तपाईंको फ्याक्स पठाउन असफल। कृपया पुनः प्रयास गर्नुहोस्',
        deleteSuccess: 'फ्याक्स सफलतापूर्वक मेटियो',
        deleteError: 'फ्याक्स मेटाउन असफल। कृपया पुनः प्रयास गर्नुहोस्',
      },
      confirmDelete: {
        title: 'फ्याक्स मेटाउनुहोस्',
        message: 'के तपाईं यो फ्याक्स मेटाउन चाहनुभएको छ?',
        button: 'मेटाउनुहोस्',
        cancel: 'रद्द गर्नुहोस्',
      },
      confirmResend: {
        title: 'फ्याक्स पुनः पठाउनुहोस्',
        message: 'के तपाईं यो फ्याक्स पुनः पठाउन चाहनुभएको छ?',
        button: 'पुनः पठाउनुहोस्',
        cancel: 'रद्द गर्नुहोस्',
      },
      emptyStateMessage: 'कुनै फ्याक्स छैन',
      status: {
        queued: 'प्रकार',
        received: 'प्राप्त गरिएको',
        sent: 'पठाइएको',
      },
      direction: {
        to: 'लाई',
        from: 'बाट',
      },
      detailsHeader: {
        status:
          '{{statusPrefix}} बाट {{statusDate}} अन्तर्गत {{statusTime}} {{directionText}}',
      },
    },

    pdfToolbar: {
      print: 'प्रिन्ट',
      download: 'डाउनलोड',
      openInNewTab: 'नयाँ टुकारा खोल्नुहोस्',
    },

    toolbar: {
      page: 'पृष्ठ',
      clearAll: 'सबै साफ गर्नुहोस्',
      potentialDuplicates: 'सम्भावित डुप्लिकेट',
    },

    global: {
      tooltip: {
        copyLink: 'क्लिपबोर्डमा लिंक प्रतिलिपि गर्नुहोस्',
        copyLinkAt: '{{timStamp}} मा लिंक प्रतिलिपि गर्नुहोस्',
        copyLinkText: 'लिंक प्रतिलिपि गर्नुहोस्',
      },
      toast: {
        moveSuccess: 'भ्वाइसमेल सफलतापूर्वक सारियो।',
        moveError: 'भ्वाइसमेल सार्न असफल।',
        deleteSuccess: 'भ्वाइसमेल मेटाइयो।',
        deleteError: 'भ्वाइसमेल मेटाउन असफल।',
        markUnreadSuccess: 'भ्वाइसमेल अपठित रूपमा चिन्हित गरियो।',
        markUnreadError: 'भ्वाइसमेल अपठित रूपमा चिन्हित गर्न असफल।',
        copyLinkSuccess: 'लिंक क्लिपबोर्डमा प्रतिलिपि गरियो।',
        copySuccess: 'क्लिपबोर्डमा प्रतिलिपि गरियो।',
        copyError: 'क्लिपबोर्डमा प्रतिलिपि गर्न असफल।',
        extensionSwitched: 'एक्सटेन्सन परिवर्तन गरियो:',
        pbxChanged: 'PBX परिवर्तन गरियो:',
      },
      input: {
        defaultPlaceholder: 'यो खाली हुनुहुन्छ',
      },
    },

    contactSearchInput: {
      placeholder: 'नाम वा नम्बर टाइप गर्नुहोस्',
      invalidPhoneNumber: 'अवैध फोन नम्बर',
    },

    newCallModal: {
      header: 'नयाँ कल',
      sendToWebPhone: 'वेब फोनमा पठाउनुहोस्',
      sendToDeskPhone: 'डेस्क फोनमा पठाउनुहोस् (Yealink)',
      from: 'बाट',
      to: 'लाई',
      answerHandsetWhenItRings: 'रिंग हुँदा ह्यान्डसेट उठाउनुहोस्।',
      attemptingToEstablishCallTo:
        '{{phoneNumber}} मा कल गर्न प्रयास गर्दैछ...',
      checkInternetConnection: 'इन्टरनेट जाँच्नुहोस् र पुनः प्रयास गर्नुहोस्।',
      tryAgain: 'पुनः प्रयास गर्नुहोस्',
      establishingCallTo: '{{phoneNumber}} मा कल जाँदैछ...',
    },

    confirmBlockNumberModal: {
      title: '{{formattedPhoneNumber}} लाई ब्लक गर्नुहोस्',
      message:
        'तपाईंको PBX ले अब यो नम्बरबाट कल, सन्देश वा फ्याक्स प्राप्त गर्ने छैन।',
      confirmText: 'नम्बर ब्लक गर्नुहोस्',
      cancelText: 'रद्द गर्नुहोस्',
      toastBlockError:
        '{{formattedPhoneNumber}} लाई ब्लक गर्न असफल। कृपया पुनः प्रयास गर्नुहोस्।',
      toastUnblockError:
        '{{formattedPhoneNumber}} लाई अनब्लक गर्न असफल। कृपया पुनः प्रयास गर्नुहोस्।',
    },

    blockedNumbers: {
      addNumber: 'नम्बर थप्नुहोस्',
      headerSubtext:
        'तल सूचीबद्ध नम्बरहरूबाट आउने सबै कल, सन्देश र फ्याक्सहरू ब्लक गरिनेछ।',
      header: 'ब्लक गरिएको नम्बरहरू',
      clearButton: 'खाली गर्नुहोस्',
      blockButton: 'नम्बर ब्लक गर्नुहोस्',
      modalSubtext:
        'तल सूचीबद्ध नम्बरहरूबाट आउने सबै कल, सन्देश र फ्याक्सहरू ब्लक गरिनेछ।',
    },

    messageInput: {
      statusMessage: {
        uploading: 'अपलोड हुँदैछ...',
        failedToUpload: 'अपलोड असफल',
      },
      attachMedia: 'मिडिया संलग्न गर्नुहोस्',
      addSnippet: 'स्निपेट थप्नुहोस्',
      emojis: 'इमोजीहरू 😃',
      sendText: 'सन्देश पठाउनुहोस्',
    },

    newThreadModal: {
      header: {
        newThread: 'नयाँ थ्रेड',
        noGroupFound: 'कुनै समूह भेटिएन',
      },
      sendButtonText: 'पठाउनुहोस्',
      contactText1: 'यो एक्सटेन्सन कुनै मेसेजिङ समूहको हिस्सा होइन।',
      contactText2:
        'admin.mangovoice.com मा जानुहोस् वा आफ्नो व्यवस्थापकलाई सम्पर्क गर्नुहोस्।',
      contactLinkText: 'सन्देश समूह भनेको के हो?',
      placeholder: 'तपाईंको सन्देश',
    },

    deleteConfirmModal: {
      title: 'भ्वाइसमेल मेटाउनुहोस्?',
      message: 'यो स्थायी हो र पूर्वावस्थामा फर्काउन सकिँदैन।',
      deleteButton: 'मेटाउनुहोस्',
      cancelButton: 'रद्द गर्नुहोस्',
    },

    emptySearch: {
      shoot: 'हाय!',
      nothingIsMatching: 'कुनै मेल खाने वस्तु भेटिएन',
      didYouSpellItRight: 'के तपाईंले सहि रूपमा टाइप गर्नुभयो?',
    },

    messageThreads: {
      emptyState: {
        title: 'कुनै सन्देश छैन',
        subtitle1: 'तपाईंले हालसम्म कुनै सन्देश पठाउनुभएको छैन',
        subtitle2: 'सन्देश पठाएर सुरुवात गर्नुहोस्',
      },
      searchPlaceholder: 'नाम वा नम्बर खोज्नुहोस्',
      allGroups: 'सबै समूहहरू',
      new: '{{count}} नयाँ - सबै हेर्नुहोस्',
      markAllRead: 'सबै पढिएको चिन्ह लगाउनुहोस्',
      buttonText: 'नयाँ सन्देश',
    },

    search: {
      placeholder: 'नाम वा नम्बर खोज्नुहोस्',
    },

    phoneOptions: {
      recent: 'हालसालै',
      missed: 'छुटेका',
    },

    chatOptions: {
      recent: 'हालसालै',
      unread: 'अपठित',
    },

    snippetOptions: {
      pbx: 'PBX',
      personal: 'व्यक्तिगत',
    },

    chatMenu: {
      label: 'स्निपेटहरू',
    },

    phoneMenu: {
      label: 'स्वत: उत्तर',
    },

    generalMenu: {
      label: 'प्रतिक्रिया पठाउनुहोस्',
    },

    experimentsMenu: {
      label: 'वेब फोन',
    },

    developMenu: {
      notifications: 'सूचनाहरू',
      contacts: 'सम्पर्कहरू',
    },

    callState: {
      inboundAnswered: 'प्राप्त कल उठाइयो',
      outboundAnswered: 'पठाइएको कल उठाइयो',
      inboundMissedOrDeclined: 'प्राप्त कल छुट्यो वा अस्वीकार गरियो',
      outboundMissedOrDeclined: 'पठाइएको कल छुट्यो वा अस्वीकार गरियो',
    },

    voicemailState: {
      received: 'भ्वाइसमेल प्राप्त गरियो',
      sent: 'तपाईंले भ्वाइसमेल पठाउनुभयो',
    },

    voicemailOptions: {
      recent: 'हालसालै',
      unread: 'अपठित',
    },

    mangoPhoneTypes: {
      mobile: 'मोबाइल',
      work: 'काम',
      home: 'घर',
    },

    mangoContactTypes: {
      mango: 'मोंगो वोइस',
    },

    newFaxModal: {
      header: 'नयाँ फ्याक्स',
      footer: {
        sendButtonText: 'पठाउनुहोस्',
      },
      loadingView: {
        sendingFax: 'फ्याक्स पठाउनुहोस्...',
      },
    },

    newFaxForm: {
      dropdownPlaceholder: 'बाट...',
      textAreaPlaceholder: 'कवर पृष्ठको नोट टाइप गर्नुहोस्',
      switchText: {
        includeCoverPage: 'कवर पृष्ठ समावेश गर्नुहोस्',
        sendEmailConfirmation: 'इमेल पुनः पठाउनुहोस्',
      },
      dropzonePlaceholder: 'तपाईं २५ मेगाबाइट फ्याक्स पठाउन सक्नुहुन्छ',
      tagInputPlaceholder: 'इमेल पत्ता टाइप गर्नुहोस् र "Enter" टाइप गर्नुहोस्',
      tagInputGuideText:
        'तपाईंले अधिकतम {{maxEmailConfirmations}} इमेल पत्ताहरू पठाउन सक्नुहुन्छ',
    },

    sizeGauge: {
      totalSize: 'कुल आकार: {{totalSize}} / {{sizeLimit}}',
      exceededSize: '{{exceededSize}} बाट बाहिर छ',
    },

    messagingPage: {
      emptyDetailViewMessage: 'कुनै थ्रेड चयन गरिएको छैन',
      errorToastMessage: 'अवैध फोन नम्बर',
      textPlaceholder: {
        receivedFile: 'प्राप्त फाइल',
        fileSent: 'फाइल पठाउनुभयो',
      },
      subheadingText: '{{phoneNumber}} बाट',
    },

    markReadModal: {
      header: 'सावधानी - सबै पढिएको चिन्ह लगाउन',
      message: 'सबै थ्रेडहरू पढिएको चिन्ह लगाउन सकिन्छ भने यो फर्काउन सकिन्छ।',
      confirmText: 'के तपाईं सुन्नुभएको छैन?',
      confirmButton: 'सुन्नुहोस्',
    },

    messageThreadHeader: {
      rename: 'नाम परिवर्तन गर्नुहोस्',
      cancel: 'रद्द गर्नुहोस्',
    },

    contentDefault: {
      placeholder: 'यहाँ फाइल ड्रैग गर्नुहोस् वा क्लिक गर्नुहोस्',
    },

    dropZoneMappings: {
      fileToLarge: {
        title: 'फाइल बडा',
        description:
          'फाइल आपलो अपलोड कर्ता बडा छ। अधिकतम फाइल आकार {{maxFileSize}}MB हो।',
      },
      fileInvalidType: {
        link: 'अधिक जान्नुहोस्',
        title: 'असमर्थित फाइल प्रकार',
        faxDescription: `फाइल असमर्थित फाइल प्रकार हो। {{link}} समर्थित फाइल प्रकारहरूको बारेमा जान्नुहोस्`,
        description: `फाइल असमर्थित फाइल प्रकार हो। समर्थित फाइल प्रकारहरूको बारेमा जान्नुहोस् {{urlLink}}`,
      },
      fileUploadFailed: {
        title: 'अपलोड असफल',
        description:
          'फाइल आपलो अपलोड कर्ता असफल भयो। कृपया पुनः प्रयास गर्नुहोस्।',
      },
      general: {
        title: 'अप्रत्याशित त्रुटि भयो',
        description: 'एक अप्रत्याशित त्रुटि भयो। कृपया पुनः प्रयास गर्नुहोस्।',
      },
    },

    voicemail: {
      emptyState: {
        title: 'कुनै भ्वाइसमेल छैन',
        subtitle1: 'तपाईं सबै कलहरू उठाउँदै हुनुहुन्छ। राम्रो गरिरहनुहोस्!',
        subtitle2:
          'यदि तपाईंले भ्वाइसमेल छुटेको अनुभव गर्नुभयो भने समर्थन सम्पर्क गर्नुहोस्।',
        buttonText: 'समर्थन सम्पर्क गर्नुहोस्',
      },
      searchPlaceholder: 'कलर नाम वा नम्बर खोज्नुहोस्',
      emptyDetailViewMessage: 'कुनै भ्वाइसमेल चयन गरिएको छैन',

      mangoModal: {
        title: 'स्थानान्तरण गर्नुहोस्',
        headerText: 'भ्वाइसमेल सार्नुहोस्',
        cancelButtonText: 'रद्द गर्नुहोस्',
        moveButtonText: 'भ्वाइसमेल सार्नुहोस्',
        selectVoicemailBoxText: 'भ्वाइसमेल बाकस चयन गर्नुहोस्...',
        markAsUnreadText: 'चयन गरिएको बाकसमा अपठित चिन्ह लगाउनुहोस्',
        destinationBoxText: 'गन्तव्य भ्वाइसमेल बाकस',
        destinationBoxWarning:
          'यदि तपाईंलाई पहुँच छैन भने यो भ्वाइसमेल अनुपलब्ध हुनेछ।',
      },

      detailView: {
        headerSubheadingText: 'बाट',
        headerSubheadingToText: 'लाई',
        audioPlayerTitle: 'भ्वाइसमेल अडियो',
        transcriptionText: 'ट्रान्सक्रिप्शन',
      },

      quickActions: {
        rewind10s: '१० सेकेन्ड पछाडि',
        play: 'प्ले',
        pause: 'पज',
        mute: 'मिउट',
        unmute: 'अनमिउट',
        fastForward10s: '१० सेकेन्ड अगाडि',
        jumpToAnswer: 'उत्तरमा जानुहोस्',
        changePlaybackSpeed: 'गति परिवर्तन गर्नुहोस्',
        downloadAudio: 'अडियो डाउनलोड गर्नुहोस्',
        seeKeyboardShortcuts: 'किबोर्ड सर्टकट हेर्नुहोस्',
      },

      loadingText: 'भ्वाइसमेल',
      transcriptionTitleText: 'ट्रान्सक्रिप्शन',

      move: {
        error: 'भ्वाइसमेल सार्न त्रुटि भयो।',
        success: 'भ्वाइसमेल सफलतापूर्वक सारियो',
        successMarkAsUnread:
          'भ्वाइसमेल सफलतापूर्वक सारियो र अपठित चिन्ह लगाइयो',
        successMarkAsRead: 'भ्वाइसमेल सफलतापूर्वक सारियो',
      },

      filter: {
        all: 'सबै',
        unread: 'अपठित',
        allInboxes: 'सबै इनबक्सहरू',
      },

      tooltip: {
        move: 'सार्नुहोस्',
        delete: 'मेटाउनुहोस्',
        markAsUnread: 'अपठित चिन्ह लगाउनुहोस्',
        markAsRead: 'पढिएको चिन्ह लगाउनुहोस्',
        blockNumber: 'नम्बर ब्लक गर्नुहोस्',
        unblockNumber: 'नम्बर अनब्लक गर्नुहोस्',
        copyLink: 'लिंक प्रतिलिपि गर्नुहोस्',
        editContact: 'सम्पर्क सम्पादन गर्नुहोस्',
        newCall: 'नयाँ कल',
        newText: 'नयाँ सन्देश',
        resendFax: 'फ्याक्स पुन: पठाउनुहोस्',
        moveFax: 'फ्याक्स सार्नुहोस्',
        newFax: 'नयाँ फ्याक्स',
        close: 'बन्द गर्नुहोस्',
      },

      copyLinkError: 'लिंक प्रतिलिपि गर्न असफल।',
    },

    fax: {
      filter: {
        all: 'सबै',
        unread: 'अपठित',
        allInboxes: 'सबै इनबक्सहरू',
        sent: 'पठाइएको',
        received: 'प्राप्त गरिएको',
      },
      tooltip: {
        pending: 'यो फैक्स प्रशोधन भइरहेको छ र चाँडै पठाइनेछ।',
      },
    },
  },
  support_phone_label: 'सहायता हटलाइन: {{phoneNumber, phone}}',
  user_profile_phone: 'तपाईंको दर्ता गरिएको फोन नम्बर: {{userPhone, phone}}',
} satisfies typeof en
